import type { ReactNode } from 'react';
import { useDraggable } from '@dnd-kit/core';

import { cn } from '../../../shared/lib/cn';
import type { TDragged } from '../lib';

// Pointer listeners only, no dnd-kit attributes: they would turn the row into a `button` and
// steal its keyboard. Keyboard users move with "Move to…".
export const DraggableRow = ({ id, children }: { id: string; children: ReactNode }) => {
  const dragged: TDragged = { kind: 'item', id };
  const { setNodeRef, listeners, isDragging } = useDraggable({ id: `item:${id}`, data: dragged });
  return (
    <div ref={setNodeRef} {...listeners} className={cn(isDragging && 'opacity-40')}>
      {children}
    </div>
  );
};
